import React, { Suspense, lazy, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { get, responseValidator } from "../scripts/api";
import API from "../urls/api";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { DeviceEnum, setAnonListConfig, setServerTime, setWebListConfig } from "../redux/slices/environmentSlice";
import moment from "moment-jalaali";
import ReactTooltip from "react-tooltip";
import MyRoutes from "./routes.index";
import { handleClearAllSelectedResources } from "../utils/component/fileManagers/fileManager.actions";
import { checkParentTarget } from "../scripts/helpers";
import { shallowEqual } from "react-redux";
moment.loadPersian();

const Error500 = lazy(() => import("../pages/errors/error500.index"));
const Loading = lazy(() => import("../utils/component/loading/loading.index"));

export default function Router(): JSX.Element {
    const dispatch = useAppDispatch();
    const { device, anonListConfig, webListConfig } = useAppSelector(
        ({ environment: { device, anonListConfig, webListConfig } }) => ({ device, anonListConfig, webListConfig }),
        shallowEqual
    );
    const [anonError, setAnonError] = useState<boolean>(false);
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        get(
            (data, status) => {
                if (responseValidator(status)) {
                    dispatch(setAnonListConfig(data.results));
                    setCounter((state) => state + 1);
                } else {
                    setAnonError(true);
                }
            },
            API.anon_list_config(),
            { limit: 1000 },
            undefined,
            false
        );
        get(
            (data, status) => {
                if (responseValidator(status)) {
                    dispatch(setWebListConfig(data.results));
                    setCounter((state) => state + 1);
                } else {
                    setAnonError(true);
                }
            },
            API.web_list_config(),
            { limit: 1000 },
            undefined,
            false
        );
        get((data, status) => {
            if (responseValidator(status)) {
                dispatch(setServerTime(data));
            }
        }, API.serverTime("v1"));
    }, []);

    const routerOnMouseDown = (e: any) => {
        if (!document.getElementById("content")?.contains(e.target)) {
            const clearSelectedAllow = ["dialog", "contextMenu", "excel-editor", "versioning-card", "dialog-react-root", "upload-root"].every(
                (item) => checkParentTarget(e, item)
            );

            if (typeof e.target.className === "string" && !e.target.className.includes("tour") && clearSelectedAllow) {
                handleClearAllSelectedResources();
            }
        }
    };

    return (
        <section onMouseDown={routerOnMouseDown}>
            <ReactTooltip effect="solid" disable={device !== DeviceEnum.desktop} scrollHide={true} />
            {anonError ? (
                <Suspense>
                    <Error500 />
                </Suspense>
            ) : counter === 2 && anonListConfig.length > 0 && webListConfig.length > 0 ? (
                <BrowserRouter>
                    <MyRoutes />
                </BrowserRouter>
            ) : (
                <Suspense>
                    <Loading />
                </Suspense>
            )}
        </section>
    );
}
